import React, { createContext } from 'react';
import axios from 'axios';

const FetchContext = createContext();
const { Provider } = FetchContext;

const kProductionEnvironment = "production";
const kStagingEnvironment = "staging";
const kLocalEnvironment = "local";

const currentEnvironment =  kProductionEnvironment;

const LOCAL_BASE_URL = "http://localhost:8088";

const PROD_BASE_URL = "https://cdn.libretto.fm";

const STAGING_BASE_URL = "https://staging.libretto.fm";

const LOCAL_CLIENT_URL = "http://localhost:3000";

const PROD_CLIENT_URL = "https://libretto.fm"

const BaseUrlForEnvironment = (environment) => {
    switch (environment) {
        case kProductionEnvironment:
            return PROD_BASE_URL;
        case kStagingEnvironment:
            return STAGING_BASE_URL;
        case kLocalEnvironment:
            return LOCAL_BASE_URL;
        default:
            return PROD_BASE_URL;
    }
}

const ClientUrlForEnvironment = (environment) => {
    switch (environment) {
        case kProductionEnvironment:
            return PROD_CLIENT_URL;
        case kStagingEnvironment:
            return LOCAL_BASE_URL;
        case kLocalEnvironment:
            return LOCAL_CLIENT_URL;
        default:
            return PROD_CLIENT_URL;
    }
}

const CLIENT_URL = ClientUrlForEnvironment(kProductionEnvironment);

const BASE_URL = BaseUrlForEnvironment(currentEnvironment);

const FetchProvider = ({ children }) => {
    const authAxios = axios.create({
        baseURL: BASE_URL,
    });

    const getBaseURL = () => {
        return BASE_URL;
    };

    const getProxiedURL = (url) => {
        // if (!url) return "";
        // const baseUrl = isProduction ? BASE_URL : LOCAL_BASE_URL;
        // const encodedUrl = encodeURIComponent(url);
        // return `${baseUrl}/proxy/${encodedUrl}`;
        return url;
    }

    const proxiedURL = (url) => {
        if (!url) return "";
        const baseUrl = BASE_URL;
        const encodedUrl = encodeURIComponent(url);
        return `${baseUrl}/proxy/${encodedUrl}`;
    }

    return (
        <Provider
            value={{
                authAxios,
                getBaseURL,
                proxiedURL,
                getProxiedURL,
            }}
        >
            {children}
        </Provider>
    );
};

export { FetchContext, FetchProvider, BASE_URL, CLIENT_URL, STAGING_BASE_URL };
